// extracted by mini-css-extract-plugin
export var buttonContent = "_3r-0";
export var centered = "_3r-1";
export var centeredFlex = "_3r-2";
export var errorText = "_3r-3";
export var icon = "_3r-4";
export var iconButtonContent = "_3r-5";
export var monospace = "_3r-6";
export var padded = "_3r-7";